import { mode, getColor } from "@chakra-ui/theme-tools";
import { ComponentStyleConfig } from "@chakra-ui/react";

const TextareaComponentStyle: ComponentStyleConfig = {
  variants: {
    outline: (props) => {
      const { theme, focusBorderColor: fc, errorBorderColor: ec } = props;

      return {
        color: mode("gray.700", "gray.100")(props),
        fontWeight: "normal",
        lineHeight: "133%",

        _hover: {
          borderColor: mode("gray.600", "whiteAlpha.400")(props)
        },

        _focusVisible: {
          borderWidth: "2px",
          borderColor: fc || mode("blue.500", "blue.200")(props),
          boxShadow: `0 0 0 1px ${
            fc || getColor(theme, mode("blue.500", "blue.200")(props))
          }`
        },

        _invalid: {
          borderWidth: "2px",
          borderColor: ec || mode("red.600", "red.300")(props),
          boxShadow: `0 0 0 1px ${
            ec || getColor(theme, mode("red.600", "red.300")(props))
          }`
        }
      };
    }
  }
};

export { TextareaComponentStyle };
